import React from 'react';
import './ImageWithClose.css';
import {IconX} from "@tabler/icons-react";

const ImageWithClose = ({src, alt}) => {
    return (

        <div className="image-container">
            <img src={src} alt={alt} className="image rahmenBildEvent roundedimage"/>
            <div className="close-icon"><IconX/></div>
        </div>
    );
};

export default ImageWithClose;
